module.exports = __webpack_public_path__ + "img/six-9.1078edc7.png";